import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const HomeAndTerritorialVisits = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <div style={{ display: 'flex', gap: '16px', width: '100%', flexWrap: 'wrap' }}>
            <Card 
                className = "flex-fill"
                title="Regulação Médica"
                value={number.formatToBRNumber(
                    chartData?.indicators?.medicalRegulation || 0
                )}
            />

            <Card
                className = "flex-fill"
                title="Sem Regulação Médica"
                value={number.formatToBRNumber(
                chartData?.indicators?.withoutMedicalRegulation || 0
                )}
            />
            
            <Card
                className = "flex-fill"
                title="Sem Localização"
                value={number.formatToBRNumber(
                chartData?.indicators?.noLocation || 0
                )}
            />
            
        </div>
    );
};
